import getDifferenceDaysPipe from 'app/utils/DifferenceDaysPipe';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import React from 'react';
import ShimmeringLoading from '../ShimmeringLoading/ShimmeringLoading';
import './FundingProgressBar.scss';

export interface IFundingProgressBar {
    progressPercentage: number;
    totalLoan: number;
    outstandingFunding: number;
    dueDate: number;
    loading: boolean;
}

const FundingProgressBar = function init(props: IFundingProgressBar): React.ReactElement {
    const {
        progressPercentage,
        totalLoan,
        outstandingFunding,
        dueDate,
        loading
    } = props;

    return (
        <div className="funding-progress">
            <div className="progress-info">
                {loading ? <ShimmeringLoading height={24} width={120} />
                : (
                <>
                    <span>Perkembangan Pendanaan</span>
                    <span>{`${progressPercentage}%`}</span>
                </>
                )}
            </div>
            <div className="progress-bar">
                {loading ? <ShimmeringLoading height={24} />
                : (
                <>
                    <div className="background" />
                    <div className="funded" style={{ width: `${progressPercentage}%` }} />
                </>
                )}
            </div>
            <div className="progress-outstanding">
                <div className="progress-amount">
                    {loading ? <ShimmeringLoading height={24} width={120} />
                    : (
                    <>
                        <span className="currency">Rp</span>
                        <span className="amount">
                            {
                                rupiahCurrencyFormatter(Number(
                                    totalLoan - outstandingFunding
                                ), true)
                            }
                        </span>
                    </>
                    )}
                </div>
                {loading ? <ShimmeringLoading height={24} width={120} />
                : (
                <span className="deadline">
                    {
                        getDifferenceDaysPipe(dueDate) > 1
                        ? `${getDifferenceDaysPipe(dueDate)} hari lagi`
                        : 'Hari terakhir'
                    }
                </span>
                )}
            </div>
        </div>
    );
};

export default FundingProgressBar;
